// src/services/socialMediaService.js

// ========================================
// YOUTUBE STATS - Updated API Format
// ========================================

export const fetchYouTubeStats = async (channelId) => {
  if (!channelId) {
    console.error('❌ YouTube Channel ID is missing');
    return null;
  }

  try {
    console.log('🔄 Fetching YouTube stats for:', channelId);
    
    const response = await fetch(
      `https://api.socialcounts.org/youtube-live-subscriber-count/${channelId}`
    );
    
    if (!response.ok) {
      throw new Error(`API returned ${response.status}`);
    }
    
    const data = await response.json();
    console.log('📦 Raw API Response:', data);
    
    let subscribers = 0;
    let views = 0;
    
    // ✅ Parse the new API format with counters object
    if (data.counters) {
      // Use estimation for most accurate real-time data
      if (data.counters.estimation) {
        subscribers = data.counters.estimation.subscriberCount || 0;
        views = data.counters.estimation.viewCount || 0;
        console.log('✅ Using estimation counters');
      }
      // Fallback to API counters
      else if (data.counters.api) {
        subscribers = data.counters.api.subscriberCount || 0;
        views = data.counters.api.viewCount || 0;
        console.log('✅ Using API counters');
      }
    }
    
    if (subscribers === 0 && views === 0) {
      console.error('❌ Could not parse YouTube data');
      return null;
    }
    
    console.log('🎉 Parsed YouTube Stats:', {
      subscribers: subscribers.toLocaleString(),
      views: views.toLocaleString()
    });
    
    return {
      subscribers: subscribers,
      views: views
    };
    
  } catch (error) {
    console.error('❌ YouTube API Error:', error);
    return null;
  }
};

// ========================================
// INSTAGRAM STATS
// ========================================

export const fetchInstagramStats = async (username) => {
  if (!username) {
    console.warn('⚠️ Instagram username not provided');
    return null;
  }

  console.log('📸 Using manual Instagram follower count');
  
  // Update this value manually with your real Instagram follower count
  return {
    followers: 100000 // 100K followers (update this number as it grows)
  };
};

// ========================================
// COMBINED STATS FETCHER
// ========================================

export const fetchAllSocialStats = async (youtubeChannelId, instagramUsername) => {
  console.log('🚀 Fetching all social stats...');
  console.log('   📍 YouTube Channel ID:', youtubeChannelId);
  console.log('   📍 Instagram Username:', instagramUsername);

  try {
    const [youtubeResult, instagramResult] = await Promise.allSettled([
      fetchYouTubeStats(youtubeChannelId),
      fetchInstagramStats(instagramUsername)
    ]);

    const youtube = youtubeResult.status === 'fulfilled' ? youtubeResult.value : null;
    const instagram = instagramResult.status === 'fulfilled' ? instagramResult.value : null;

    console.log('📊 Combined Results:', {
      youtube: youtube ? `${youtube.subscribers.toLocaleString()} subs, ${youtube.views.toLocaleString()} views` : 'Failed',
      instagram: instagram ? `${instagram.followers.toLocaleString()} followers` : 'Failed'
    });

    return {
      youtube: youtube,
      instagram: instagram
    };

  } catch (error) {
    console.error('❌ Error fetching social stats:', error);
    return {
      youtube: null,
      instagram: null
    };
  }
};
